import { useParams } from "react-router";
import { DaCheckEmail } from "../../components/DaCheckEmail/DaCheckEmail";

function DaCheckEmailPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaCheckEmail /> : null}
    </div>
  );
}

export default DaCheckEmailPage;
